import React from "react";
import { Modal } from "antd";
import {
  MoneyAdd01Icon,
  ChartRingIcon,
  ChartLineData01Icon,
} from "@hugeicons/core-free-icons";

import HugeIcon from "src/components/HugeIcon";
import { Button, DialogActions } from "src/components/ui";
import { scrim } from "src/theme/ui";
import { Body, Lead, Steps, Step, StepMark, StepText, StepTitle, StepNote } from "./style/modal";

/**
 * The greeting a new account sees once, on its first dashboard.
 *
 * Built on the shared dialog chrome — `fina-dialog` gives the surface, the
 * hairline head, the sunk foot band and the close control — rather than the
 * bespoke shell this used to carry. That shell was 880px wide and locked to a
 * 496px height by its image column, with the picture scaled three times and
 * rotated thirty-five degrees behind a blur; the text was pushed sideways by
 * a translateX(10%), and the action, being a flex item inside a container
 * with height: 100%, stretched into a 205 by 353 slab of flat blue.
 *
 * The decorative panel is gone rather than repaired, and what replaced it is
 * the three things this screen is for. A first-run dialog that only says
 * "welcome" spends someone's attention without returning anything.
 */
const StartModal = ({ isVisible, onDone }) => {
  return (
    <Modal
      wrapClassName="fina-dialog"
      maskStyle={{ background: scrim, backdropFilter: "none" }}
      title="Welcome to your dashboard"
      visible={isVisible}
      /* Closing it any way at all counts as having seen it. */
      onCancel={onDone}
      /* A width in pixels, sized to what it holds — never a percentage. */
      width={460}
      footer={[
        <DialogActions key="actions">
          {/* The product's own button, not the older one this had: accent
              fill, white label, corner from height. It carried a circled
              arrow before, which is a flourish the system does not use. */}
          <Button key="done" variant="primary" size="lg" onClick={onDone}>
            Get started
          </Button>
        </DialogActions>,
      ]}
    >
      <Body>
        <Lead>This is where you invest and manage your account.</Lead>

        <Steps>
          <Step>
            <StepMark>
              <HugeIcon icon={MoneyAdd01Icon} size={18} />
            </StepMark>
            <StepText>
              <StepTitle>Add cash</StepTitle>
              <StepNote>Fund your account by bank transfer.</StepNote>
            </StepText>
          </Step>

          <Step>
            <StepMark>
              <HugeIcon icon={ChartRingIcon} size={18} />
            </StepMark>
            <StepText>
              <StepTitle>Invest it</StepTitle>
              <StepNote>Put it into a smartfolio that suits you.</StepNote>
            </StepText>
          </Step>

          <Step>
            <StepMark>
              <HugeIcon icon={ChartLineData01Icon} size={18} />
            </StepMark>
            <StepText>
              <StepTitle>Follow it</StepTitle>
              <StepNote>Positions and activity appear here as they settle.</StepNote>
            </StepText>
          </Step>
        </Steps>
      </Body>
    </Modal>
  );
};

export default StartModal;
